// 警告： server.defaults.baseURL = '/prod-api/largescreen';
import { request } from '@/api/request';
import store from '@/store';
import axios from 'axios';
import { GetFamilyName } from '@/utils/familyNames';

const CancelToken = axios.CancelToken;

// 把 weatherFlag 和 typeCode 格式的预警数据转化成 type,category,level
const formatWarning = function (weatherFlag, typeCode) {
  let category = '';
  let level = '';
  let type = '';
  // typeCode: 预警类型Code
  //   p00开头为气象预警(weatherFlag = 1) 1热力预警 2进度预警，(weatherFlag = 0)
  // weatherFlag	string是否天气预警 1是0否
  if (weatherFlag == '1') {
    category = typeCode && typeCode.slice(1, 5); // p0020003 -> 0020
    level = typeCode && typeCode.slice(5, 8); // p0020003 -> 003
    type = 'weather';
  } else {
    category = '0';
    level = typeCode;
    type = typeCode == '1' ? 'thermodynamic' : typeCode == '2' ? 'progression' : `typeCode:${v.typeCode},weatherFlag:${v.weatherFlag}`;
  }
  return { category, level, type };
};

// 获取字典
export function getDictData(dict) {
  const url = `/largescreen/job/type/${dict}`;
  return request({ url }).then((res) => res);
}

// 区域点位维护-根据父级ID查询下级区域列表
export function getAreaLonAndLat(parentId) {
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const url = '../system/area/maintain/getAreaListByParentId/' + parentId;
    request({ url })
      .then((res) => {
        let points = (res || []).map((v) => {
          return {
            areaName: v.areaName,
            areaId: v.areaId,
            // lon: v.lon, // 原始点
            // lat: v.lat,
            lon: v.longitude, // 修正后的点
            lat: v.latitude,
          };
        });
        resolve(points);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}

// 统计数值
export function statistic(data, headers = {}) {
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const url = '/largeScreen/aidispatch/getVehicleCount';
    const params = {
      ...data,
      machineryType: store.getters.getMachineryType || 0, // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
      _unpack: true, // 不将 rss.data 变成 data
    };
    request({
      method: 'get',
      url,
      params,
      headers: {
        cancelToken: new CancelToken(function (cancel) {
          Cancel = cancel;
        }),
        ...headers,
      },
    })
      .then((res) => {
        const data = (res && res.data) || {};
        resolve(data);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}
// 农情风险多维度AI预警
export function warningCategories(data, headers = {}) {
  let Cancel = () => {};
  let r1Cancel = () => {};
  let r2Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    // 查询热力、进度预警列表
    const req1 = request({
      method: 'get',
      url: '/largeScreen/aidispatch/getHeatAndProcessWarnList',
      params: {
        ...data,
        machineryType: store.getters.getMachineryType || 0, // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
        _unpack: true, // 不将 rss.data 变成 data
      },
      headers: {
        cancelToken: new CancelToken(function (cancel) {
          r1Cancel = cancel;
        }),
        ...headers,
      },
    });
    // 气象预警事件列表（列表展示，点击弹详情）
    const req2 = request({
      method: 'get',
      url: '/largeScreen/aidispatch/getWeatherWarnList',
      params: {
        ...data,
        machineryType: store.getters.getMachineryType || 0, // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
        _unpack: true, // 不将 rss.data 变成 data
      },
      headers: {
        cancelToken: new CancelToken(function (cancel) {
          r2Cancel = cancel;
        }),
        ...headers,
      },
    });
    Promise.all([req1, req2])
      .then(([r1, r2]) => {
        // console.log('三个预警.res', [r1, r2]);
        // {id, title, time, type}
        const weather = (r2?.data || [])
          .filter((v) => v.type)
          .map((v) => {
            const category = (v.type || '').substr(1, 4); // "p0007004".substr(1,4) -> 0007
            const level = (v.type || '').substr(5, 3); // "p0007004".substr(5,3) -> 004
            return {
              ...v,
              category,
              level,
              type: 'weather',
            };
          });
        const thermodynamic = (r1?.data?.heat || [])
          .filter((v) => v.type)
          .map((v) => {
            return {
              ...v,
              category: '0',
              level: v.type,
              type: 'thermodynamic',
            };
          });
        const progression = (r1?.data?.process || []).map((v) => {
          return {
            ...v,
            category: '0',
            level: v.type,
            type: 'progression',
          };
        });
        const data = [
          { label: '气象预警', value: weather.length, list: weather },
          { label: '收割进度预警', value: progression.length, list: progression },
          { label: '收割热力预警', value: thermodynamic.length, list: thermodynamic },
        ];
        resolve(data);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = () => {
    try {
      r1Cancel();
    } catch (e) {
      console.log(e);
    }
    try {
      r2Cancel();
    } catch (e) {
      console.log(e);
    }
  };
  return promise;
}

// 预警项下拉项，用来过滤地图上的预警图标
export function groupedWarnings(data, headers = {}) {
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const url = '/largeScreen/aidispatch/getWarnTypeList';
    const params = {
      ...data,
      machineryType: store.getters.getMachineryType || 0, // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
      _unpack: true, // 不将 rss.data 变成 data
    };
    request({
      method: 'get',
      url,
      params,
      headers: {
        cancelToken: new CancelToken(function (cancel) {
          Cancel = cancel;
        }),
        ...headers,
      },
    })
      .then((res) => {
        const list = ((res && res.data) || []).map((v) => {
          const { category, level, type } = formatWarning(v.weatherFlag, v.typeCode);
          return {
            ...v,
            label: v.name,
            type, // 气象weather,热力thermodynamic,进度progression
            category,
            level: 1, // UI 强制要求用 1（红色的）作为图标
            selected: 1,
            disabled: 0,
            count: 0,
          };
        });
        resolve(list);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}

// 预警详情
export function getWarningDetail(data, headers = {}) {
  const { type, id } = data || {};
  const urls = {
    // 收割热力:thermodynamic,收割进度:progression,天气weather
    weather: `/largeScreen/aidispatch/weatherWarnRecord/${id}`,
    thermodynamic: `/largeScreen/aidispatch/warnRecord/${id}`,
    progression: `/largeScreen/aidispatch/warnRecord/${id}`,
  };
  const url = urls[type] || `找不到预警详情的接口[${type}]`;
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const params = {
      ...data,
      _unpack: true, // 不将 rss.data 变成 data
    };
    request({
      method: 'get',
      url,
      params,
      headers: {
        cancelToken: new CancelToken(function (cancel) {
          Cancel = cancel;
        }),
        ...headers,
      },
    })
      .then((res) => {
        const data = res?.data || {};
        let html = [];
        let category = '';
        let level = '';
        let answer = '';
        try {
          answer = JSON.parse(data?.reply || '{}');
        } catch (e) {
          answer = { 数据解析失败: '回复数据解析失败' };
        }
        // 某个气象的预警
        if (type == 'weather') {
          category = (data.wholeTypeCode || '').substr(1, 4); // "p0007004".substr(1,4) -> 0007
          level = (data.wholeTypeCode || '').substr(5, 3); // "p0007004".substr(5,3) -> 004
          html.push(`<h2>一、事前建议</h2>`);
          for (const key in answer.事前建议) {
            if (Object.prototype.hasOwnProperty.call(answer.事前建议, key)) {
              const list = answer.事前建议[key] || [];
              html.push(`<h3>${key}</h3>`);
              html.push('<ol>');
              list.forEach((element) => {
                html.push(`<li>${element}</li>`);
              });
              html.push('</ol>');
            }
          }
          html.push(`<h2>二、事后建议</h2>`);
          for (const key in answer.事后建议) {
            if (Object.prototype.hasOwnProperty.call(answer.事后建议, key)) {
              const list = answer.事后建议[key] || [];
              html.push(`<h3>${key}</h3>`);
              html.push('<ol>');
              list.forEach((element) => {
                html.push(`<li>${element}</li>`);
              });
              html.push('</ol>');
            }
          }
          html.push(`<h2>三、相关合作社信息</h2>`);
          const list = answer.相关合作社信息 || [];
          if (!list || !list.length) {
            html.push(`<p>暂无相关合作社信息</p>`);
          }
          list.forEach((element) => {
            html.push('<ul>');
            for (const key in element) {
              if (Object.prototype.hasOwnProperty.call(element, key)) {
                const v = element[key];
                html.push(`<li><strong>${key}：</strong>${v}</li>`);
              }
            }
            html.push('</ul>');
          });
        }
        // 某个预警：收割热力、收割进度
        else if (type == 'thermodynamic' || type == 'progression') {
          category = '0';
          level = data.level;
          // if (answer.需求农机类型) {
          //   html.push(`<h2>需求农机类型</h2>`);
          //   html.push(`<p>${answer.需求农机类型}</p>`);
          // }
          // if (answer.需求农机数量) {
          //   html.push(`<h2>需求农机数量</h2>`);
          //   html.push(`<p>${answer.需求农机数量}</p>`);
          // }
          // if (answer.影响因素) {
          //   html.push(`<h2>影响因素</h2>`);
          //   html.push(`<p>${answer.影响因素}</p>`);
          // }
          // if (answer.调度建议) {
          //   html.push(`<h2>调度建议</h2>`);
          //   html.push(`<p>${answer.调度建议}</p>`);
          // }
          if (answer.影响因素 || answer.调度建议) {
            html.push(`<h2>一、影响因素</h2>`);
            html.push(`<p>${answer.影响因素 || ''}${answer.调度建议 || ''}${!answer.影响因素 && !answer.调度建议 ? '暂无信息' : ''}</p>`);
          }
          html.push(`<h2>二、推荐的合作社</h2>`);
          const list = answer.推荐的合作社 || [];
          if (!list || !list.length) {
            html.push(`<p>暂无相关合作社信息</p>`);
          }
          list.forEach((element) => {
            html.push('<ul>');
            for (const key in element) {
              if (Object.prototype.hasOwnProperty.call(element, key)) {
                const v = element[key];
                html.push(`<li><strong>${key}：</strong>${v}</li>`);
              }
            }
            html.push('</ul>');
          });
        }
        if (data.deepThink) {
          data.deepThink = data.deepThink
            .split(/\n\s*\n/)
            .filter(Boolean) // 过滤掉数组中的空字符串
            .map((v) => `<p>${v}</p>`)
            .join('\n');
        } else {
          data.deepThink = '<p>思考中，请稍后再回来查看…</p>';
        }
        // console.log(html);
        resolve({ ...data, type, category, level, answer: html.join('') });
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}

// AI智能机手调度
export function driverDispatch(data, headers = {}) {
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const url = '/largeScreen/aidispatch/getFarmInfoList';
    const params = {
      ...data,
      machineryType: store.getters.getMachineryType || 0, // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
      _unpack: true, // 不将 rss.data 变成 data
    };
    request({
      method: 'get',
      url,
      params,
      headers: {
        cancelToken: new CancelToken(function (cancel) {
          Cancel = cancel;
        }),
        ...headers,
      },
    })
      .then((res) => {
        const list = ((res && res.data) || []).map((item) => {
          let drivers = [];
          let cooperatives = [];
          (item.vehicleList || []).forEach((v) => {
            const familyName = GetFamilyName(v.name, true); // 获取姓氏
            drivers.push({
              type: 'driver',
              company: v.cooperationName,
              name: v.name,
              familyName,
              nickname: familyName && `${familyName}师傅`,
              phone: v.phone,
              maskedPhone: v.phone && v.phone.replace(/(?<=\d{3})\d{4}(?=\d{4})/, '****'),
              model: v.model, // 机型
              address: v.address && v.address.replace(/<span[^>]*>.*<\/span>/, ''),
              distance: v.distance,
              advantage: v.advantage, // 优势
            });
          });
          if (item.cooperationInfo) {
            const familyName = GetFamilyName(item.cooperationInfo.name, true);
            cooperatives.push({
              type: 'cooperative',
              company: item.cooperationInfo.cooperationName,
              name: item.cooperationInfo.name,
              familyName,
              nickname: familyName && `${familyName}师傅`,
              phone: item.cooperationInfo.phone,
              maskedPhone: item.cooperationInfo.phone && item.cooperationInfo.phone.replace(/(?<=\d{3})\d{4}(?=\d{4})/, '****'),
              model: item.cooperationInfo.model,
              address: item.cooperationInfo.address && item.cooperationInfo.address.replace(/<span[^>]*>.*<\/span>/, ''),
              distance: item.cooperationInfo.distance,
              advantage: item.cooperationInfo.advantage,
            });
          }
          return {
            farmInfo: item.farmInfo
              ? {
                  ...item.farmInfo,
                  // familyName: GetFamilyName(item.farmInfo.realName, true),
                  nickname: GetFamilyName(item.farmInfo.realName, true) && `${GetFamilyName(item.farmInfo.realName, true)}师傅`,
                  jobStartTime: item.farmInfo.jobStartTime && item.farmInfo.jobStartTime.replace(/年|月/g, '.').replace(/日/g, ''),
                  jobEndTime: item.farmInfo.jobEndTime && item.farmInfo.jobEndTime.replace(/年|月/g, '.').replace(/日/g, ''),
                }
              : {},
            drivers,
            cooperatives,
          };
        });
        resolve(list);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}

// 全县三夏机收完成进度 // 全县三秋机收完成进度
export function seasonProgress(data, headers = {}) {
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const url = '/largeScreen/aidispatch/getProgressList';
    const params = {
      ...data,
      machineryType: store.getters.getMachineryType || 0, // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
      _unpack: true, // 不将 rss.data 变成 data
    };
    request({
      method: 'get',
      url,
      params,
      headers: {
        cancelToken: new CancelToken(function (cancel) {
          Cancel = cancel;
        }),
        ...headers,
      },
    })
      .then((res) => {
        const list = ((res && res.data) || []).map((v) => {
          // v.warnCount = Math.floor(Math.random() * 100) % 2;
          // v.plantingArea = (Math.random() * 100).toFixed(0);
          // v.progress = (Math.random() * 100).toFixed(1);
          // v.completedArea = (v.plantingArea * v.progress) / 100;
          // v.areaName = v.areaName + v.warnCount;
          return {
            ...v,
            warning: v.warnCount && v.warnCount > 0 ? true : false, // 预警数量，当前区域有预警则数量>0
            areaName: v.areaName && v.areaName, // 区域名称
            plantingArea: v.plantingArea || 0, // 种植面积
            completedArea: v.completedArea || 0, // 已完成作业面积
            progress: v.progress || 0, // 完成进度
          };
        });
        resolve(list);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}

// 三夏三秋收割热力情况
export function harvestingProgress(data, headers = {}) {
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const url = '/largeScreen/aidispatch/getHearGapCountList?_usage=ShougeReliQingkuan';
    const params = {
      ...data,
      machineryType: store.getters.getMachineryType || 0, // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
      _unpack: true, // 不将 rss.data 变成 data
    };
    request({
      method: 'get',
      url,
      params,
      headers: {
        cancelToken: new CancelToken(function (cancel) {
          Cancel = cancel;
        }),
        ...headers,
      },
    })
      .then((res) => {
        const list = ((res && res.data) || []).map((v) => ({
          ...v,
          // areaCode	string区域Code
          // areaName	string区域名称
          gapCount: v.gapCount || 0, // gapCount	number预计缺口数量（台）
          heat: v.heat || 0, // heat	number热力度
          vehicleCount: v.vehicleCount || 0, // vehicleCount	number预估农机（联合收割机、玉米收获机）数量（台）
          levelName: v.level && '优良中低'.split('')[parseFloat(v.level) - 1], // 1234->优良中低
        }));
        resolve(list);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}

// 地图上的：收割热力图、收割进度图
export function heatmap(data, headers = {}) {
  const crops = { SX: ['小麦'], SQ: ['玉米'] }[data && data.season] || [];
  const cropString = crops.join('');
  let r1Cancel = () => {};
  let r2Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const req1 = harvestingProgress(data, headers);
    const req2 = seasonProgress(data, headers);
    r1Cancel = req1.cancel;
    r2Cancel = req2.cancel;
    Promise.all([req1, req2])
      .then(([r1, r2]) => {
        // console.log('%c热力图', 'color:#CC0', { r1, r2 });
        const data = {
          thermodynamic: r1.map((v) => ({
            areaId: v.areaCode,
            value: (v.heat || 0) / 100,
            areaName: v.areaName,
            date: v.time,
            attrs: [
              { label: '预估收割机数量', value: v.vehicleCount, unit: '台' }, // （联合收割机、玉米收获机）
              { label: '理论需求量', value: v.demand, unit: '台' },
              { label: '预估缺口数量', value: v.gapCount, unit: '台' },
              { label: '热力度', value: v.heat, unit: '%' },
              { label: `${cropString}种植面积`, value: v.plantingArea, unit: '亩' },
            ],
          })),
          progression: r2.map((v) => ({
            areaId: v.areaCode,
            value: (v.progress || 0) / 100,
            areaName: v.areaName,
            date: v.time,
            attrs: [
              { label: `${cropString}种植面积`, value: v.plantingArea || 0, unit: '亩', order: 1 },
              { label: '预估已完成收割面积约', value: v.completedArea || 0, unit: '亩' },
              { label: '预估收割进度', value: v.progress || 0, unit: '%' },
            ],
          })),
        };
        resolve(data);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = () => {
    try {
      r1Cancel();
    } catch (e) {
      console.log(e);
    }
    try {
      r2Cancel();
    } catch (e) {
      console.log(e);
    }
  };
  return promise;
}

// 标在地图上的预警事件
export function warnings(data, headers = {}) {
  let Cancel = () => {};
  let promise = new Promise((resolve, reject) => {
    const url = '/largeScreen/aidispatch/getAllWarnList';
    const params = {
      ...data,
      machineryType: store.getters.getMachineryType || 0, // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
      _unpack: true, // 不将 rss.data 变成 data
    };
    request({
      method: 'get',
      url,
      params,
      headers: {
        cancelToken: new CancelToken(function (cancel) {
          Cancel = cancel;
        }),
        ...headers,
      },
    })
      .then((res) => {
        let data = {};
        ((res && res.data) || []).forEach((p) => {
          const list = (p.list || []).map((v) => {
            const { category, level, type } = formatWarning(v.weatherFlag, v.type);
            return {
              key: v.id ? `${v.id}-${v.areaCode}` : v.id, // 多个地区的预警可能是同一个，为了区分为id补一部分以让其唯一
              dataId: v.id,
              type, // 气象weather,热力thermodynamic,进度progression
              category,
              level,
            };
          });
          const key = `${p.lon}, ${p.lat}`;
          data[key] = list;
        });
        resolve(data);
      })
      .catch((res) => {
        reject(res);
      });
  });
  promise.cancel = Cancel;
  return promise;
}
